
/**
 * @desc    Functions for fact cards
 */
function init() {

	function isOnScreen(elem) {
		// if the element doesn't exist, abort
		if( elem.length == 0 ) {
			return;
		}
		var $window = $(window)
		var viewport_top = $window.scrollTop()
		var viewport_height = $window.height()
		var viewport_bottom = viewport_top + viewport_height
		var $elem = $(elem)
		var top = $elem.offset().top
		var height = $elem.height()
		var bottom = top + height

		return (top >= viewport_top && top < viewport_bottom) ||
		(bottom > viewport_top && bottom <= viewport_bottom) ||
		(height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
	}

	$( document ).ready( function() {
		$(window).on("load resize scroll",function(e) {

			if( isOnScreen( $( '.facts-wrap' ) ) ) {
				// alert( 'The specified container is in view.' );
				$(".fact-card").each(function(index) {
					var self = this;
				    if (!$(self).hasClass("visible")) {
				    	setTimeout( function(){
				    		$(self).addClass( "visible" );
				    	}, index*100);
				    }
				});
	 		}	
		});
	});

	$( ".fact-card .button" ).click(function() {
		$(this).siblings(".fact").slideToggle();
		$(this).parent().siblings(".gradient").toggleClass( "active" );
		$(this).parent(".copy").toggleClass( "active" );
		$(this).toggleClass( "active" );
	});
}

/**
 * Public API
 * @type {Object}
 */
module.exports = {
	init: init
};



// WEBPACK FOOTER //
// ./scripts/components/fact-cards.js